// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"da1d3a70","605":"d87399f7"}[chunkId] + ".chunk.js";
};